module.exports = require('./lib/wix-data-schema-api')
